var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// src/asset-config.tsx
import React from "react";
import { Image } from "@leagueplatform/genesis-commons";
var customAssetConfig = null;
function setCustomAssets(config) {
  if (!config)
    throw new Error("You must provide an Custom Asset config");
  customAssetConfig = __spreadValues(__spreadValues({}, customAssetConfig), config);
}
function setDefaultAssets(config) {
  if (!config)
    throw new Error("You must provide a default Custom Asset config");
  customAssetConfig = __spreadValues(__spreadValues({}, config), customAssetConfig);
}
function getAssetConfig() {
  if (!customAssetConfig)
    throw new Error("Custom Asset configuration is not defined.");
  return customAssetConfig;
}
function renderComponent(asset, props) {
  const { alt = "" } = props;
  if (typeof asset !== "string") {
    const Component = asset;
    if (props) {
      return /* @__PURE__ */ React.createElement(Component, __spreadValues({}, props));
    }
    return /* @__PURE__ */ React.createElement(Component, null);
  }
  return /* @__PURE__ */ React.createElement(
    Image,
    __spreadProps(__spreadValues({}, props), {
      src: asset,
      alt
    })
  );
}
function handleStaticAsset(assetKey, options) {
  if (!customAssetConfig) {
    throw new Error("You must provide an Custom Asset config");
  }
  const { isComponent, props = {} } = options || {};
  const asset = customAssetConfig[assetKey];
  if (isComponent) {
    return renderComponent(asset, props);
  }
  if (!asset) {
    throw new Error(
      `It looks like the asset "${assetKey}" you are trying to render is not set in the assets map (e.g. asset-map.tsx). Please review your asset map and make sure all assets are defined.`
    );
  }
  if (typeof asset !== "string" && !isComponent) {
    throw new Error(
      `It looks like the asset "${assetKey}" you are trying to render is a React Component or function. Set isComponent to true in order to do so.`
    );
  }
  return asset;
}
export {
  getAssetConfig,
  handleStaticAsset,
  setCustomAssets,
  setDefaultAssets
};
//# sourceMappingURL=index.js.map